import React from 'react';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import { formatDateShort } from '~/lib/DateTime';
import { ucfirst } from '~/lib/Utils.js';

const InvoiceHistory = ({ invoices }) => {
    if (!invoices || invoices.length === 0) {
        return (
            <div className="panel p-8 text-center text-gray-400 italic">
                No invoices found
            </div>
        );
    }

    const getStatusBadgeClass = (status) => {
        switch (status) {
            case 'paid':
                return 'bg-green-100 text-green-800';
            case 'sent':
                return 'bg-blue-100 text-blue-800';
            case 'overdue':
                return 'bg-red-100 text-red-800';
            case 'draft':
            default:
                return 'bg-gray-100 text-gray-800';
        }
    };

    const handleInvoiceClick = (invoice) => {
        if (invoice.view_link) {
            window.open(invoice.view_link, '_blank');
        }
    };

    return (
        <div className="space-y-2 panel pl-4">
            {invoices.map((invoice, idx) => (
                <div
                    key={invoice.id}
                    className={`py-3 pr-4 cursor-pointer ${idx > 0 ? 'border-t' : ''}`}
                    onClick={() => handleInvoiceClick(invoice)}
                >
                    <div className="flex items-center justify-between">
                        <div className="flex-1">
                            <div className="flex items-center gap-3">
                                <div className="font-medium">
                                    Invoice #{invoice.invoice_number}
                                </div>
                                <span
                                    className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusBadgeClass(
                                        invoice.status,
                                    )}`}
                                >
                                    {ucfirst(invoice.status)}
                                </span>
                            </div>
                            <div className="text-sm text-gray-500 mt-1">
                                {invoice.due_at && (
                                    <span>
                                        Due: {formatDateShort(invoice.due_at)}
                                    </span>
                                )}
                                {invoice.sent_at && (
                                    <span className="ml-3">
                                        Sent: {formatDateShort(invoice.sent_at)}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="text-right">
                            <div className="font-semibold">
                                {formatCurrency(invoice.total)}
                            </div>
                            {invoice.status === 'paid' && (
                                <div className="text-xs text-gray-500">
                                    Paid
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default InvoiceHistory;

